import { createRequestActionsSet } from "@store/shared/requestState"

export const fetchStatuses = createRequestActionsSet("statuses", "FETCH_STATUSES")
